define('uikit/views/table.add',['require','exports','module','underscore','../elements/button','./table.selected'],function(require, exports, module){
  var _ = require('underscore');
  var ButtonView = require('../elements/button');
  var TableSelectedView = require('./table.selected');

  var TableAddView = TableSelectedView.extend({

    internalViews: {
      view: ButtonView
    },

    internalViewOptions: {
      view: { 
        circular: true,
        icon: 'plus', 
        size: 'mini', 
        className: ButtonView.prototype.className + ' invertable'
      }
    },

    initialize: function() {
      TableSelectedView.prototype.initialize.apply(this, arguments);

      // Setup listener on the button view
      this.view.on('press', function() {
        var row = this.getRow();

        row.trigger('add', this);
      }, this);
    }

  });

  module.exports = TableAddView;
});
